import { CommissionDealer } from '../../../../generated/ApiClient';

export function getDefaultCommissionDealer(commissionDealers: CommissionDealer[]) {
  return commissionDealers.length === 1
    ? commissionDealers[0].value
    : commissionDealers.find((x) => x.isDefault)?.value;
}
